module.exports = __webpack_public_path__ + "static/media/swan.6a1a006f.jpg";